import moment from 'moment';

export const UNALLOCATED = 'unallocated';
export const DECLINED = 'declined';
export const PENDING = 'pending';
export const ACCEPTED = 'accepted';

export const sortBookingsByCollectionDateAscending = (bookings) => {
  if (!bookings) return [];
  return bookings.sort((a, b) => (a.collectionDateTimeLocal < b.collectionDateTimeLocal ? -1 : 1));
};

export const getActiveTrips = (trips) => trips.filter((trip) => trip.status === 'active');

export const getTripByType = (trips, type) => trips.find((trip) => trip.type === type);

export const getLeastProgressedTrip = (trips) => {
  /**
   * A booking has two legs, customer-garage & garage-customer. If one is allocated but the other isn't,
   * we want to make sure the leg (trip) in the least progressed allocation status (in this case,
   * unallocated), is displayed so that it can be allocated.
   *
   * e.g.
   * - When the customer-garage trip is unallocated but garage-customer trip is pending,
   *   the booking will be assigned to the Unallocated column
   * - When the garage-customer trip is unallocated but customer-garage trip is pending,
   *   the booking will be assigned to the Unallocated column

   * trips = [
   *   {type: customer-garage, allocationStatus: Pending},
   *   {type: garage-customer, allocationStatus: Unallocated} - [least progressed trip]
   * ]
   */
  if (!trips || !trips.length) return null;

  const allocationStatusPriorities = {
    [UNALLOCATED]: 1,
    [DECLINED]: 2,
    [PENDING]: 3,
    [ACCEPTED]: 4,
  };

  const collectionTrip = getTripByType(trips, 'customer-garage');
  const deliveryTrip = getTripByType(trips, 'garage-customer');

  const collectionTripPriority = allocationStatusPriorities[collectionTrip?.allocationStatus];
  const deliveryTripPriority = allocationStatusPriorities[deliveryTrip?.allocationStatus];

  if (!collectionTripPriority && !deliveryTripPriority) return null;

  if (!collectionTripPriority) return deliveryTrip;
  if (!deliveryTripPriority) return collectionTrip;

  if (collectionTripPriority === deliveryTripPriority) return collectionTrip;

  const leastProgressedTrip = collectionTripPriority > deliveryTripPriority ? deliveryTrip : collectionTrip;
  return leastProgressedTrip;
};

export const momentArray = (dateRangeArray) =>
  dateRangeArray ? dateRangeArray.map((date) => moment(date)) : null;

export const applyDateRangeFilter = (booking, dateRange) => {
  if (!dateRange || !dateRange.length) return true;

  const filterStartDate = moment(dateRange[0]);
  const filterEndDate = moment(dateRange[1]);
  const collectionDate = moment(booking.collectionDateTimeLocal);
  const collectionDateInRange = moment(collectionDate).isBetween(filterStartDate, filterEndDate, 'day', '[]');

  return collectionDateInRange;
};
